export default "__VITE_ASSET__P5Z77aID__"